/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
button.iconButton {
  --icon-button-drop-shadow: 3px 3px 0 0 rgba(0, 0, 0, 0.45);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0px;
  border-radius: var(--radius-sm, 0.25rem);
  border-style: var(--tw-border-style);
  border-width: 1px;
  --tw-border-style: solid;
  border-style: solid;
  border-color: var(--color-gray-300, #d4d4d4);
  background-color: transparent;
  color: var(--color-emphasis-medium, #525252);
  cursor: pointer;
  appearance: none;
}
.sm {
  height: calc(var(--spacing, 0.25rem) * 8);
  width: calc(var(--spacing, 0.25rem) * 8);
  min-width: calc(var(--spacing, 0.25rem) * 8);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
}
button.sm {
  border-color: transparent;
}
.md {
  height: calc(var(--spacing, 0.25rem) * 10);
  width: calc(var(--spacing, 0.25rem) * 10);
  min-width: calc(var(--spacing, 0.25rem) * 10);
  font-size: var(--text-lg, 1.125rem);
  line-height: var(--tw-leading, var(--text-lg--line-height, calc(1.75 / 1.125)));
}
.iconButton[aria-pressed="true"], .iconButton[aria-expanded="true"] {
  border-color: var(--color-primary-500);
  background-color: var(--color-primary-100);
  color: var(--color-primary-500);
  box-shadow: inset 0 0 0 1px var(--color-primary-500);
}
.iconButton:hover:not(:disabled) {
  border-color: var(--color-gray-500, #737373);
  box-shadow: inset 0 0 0 1px var(--color-gray-500), var(--icon-button-drop-shadow);
}
.iconButton[aria-pressed="true"]:hover:not(:disabled), .iconButton[aria-expanded="true"]:hover:not(:disabled) {
  border-color: var(--color-primary-800);
  color: var(--color-emphasis-ultra, var(--color-primary-400));
  box-shadow: inset 0 0 0 1px var(--color-primary-800), var(--icon-button-drop-shadow);
}
.iconButton:disabled {
  opacity: 30%;
  cursor: not-allowed;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
    }
  }
}
